import React from 'react';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';

import './style.sass';

const Recommendations = ({ listRecommendations }) => {
    return (
        <div className="otpBank-recommendations">
            <FullWrapper>
                <div className="otpBank-recommendationsWrapper">
                    <div className="otpBank-recommendationsContainer">
                        <div className="otpBank-recommendationsSubtitle">
                            Рекомендации для&nbsp;похожих проектов
                        </div>
                        {listRecommendations.map((item, index) => (
                            <div className="otpBank-recommendationsList" key={index}>
                                <div className="otpBank-recommendationsListNumber">
                                    {item.number}
                                </div>
                                <div
                                    className="otpBank-recommendationsListText"
                                    dangerouslySetInnerHTML={{ __html: item.text }}
                                />
                            </div>
                        ))}
                    </div>
                </div>
            </FullWrapper>
        </div>
    );
};

export default Recommendations;
